"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryDataResponse = void 0;
const enums_1 = require("../enums");
class InventoryDataResponse {
}
exports.InventoryDataResponse = InventoryDataResponse;
//# sourceMappingURL=inventory-data.response.js.map